$(document).ready(function() {
  let $window = $(window);
  let __isTabletAndUp = $(window).width() > 641;

  // const PRESSED_KEYS = new Set();
  // $(document)
  //     .on('keydown', function(e) {
  //       PRESSED_KEYS.add(e.which);
  //       // 16 is "shift", 91 is "command"
  //       if (PRESSED_KEYS.has(91) && PRESSED_KEYS.has(16)) {
  //         // alert(`Please do not try to take screenshot`);
  //         e.preventDefault();
  //         e.stopPropagation();
  //         // hide images
  //         $('body').addClass('hide-image');
  //         return false;
  //       }
  //       // console.log('PRESSED:', Array.from(PRESSED_KEYS).join(','));
  //     })
  //     .on('keyup', function(e) {
  //       PRESSED_KEYS.delete(e.which);
  //       if (!PRESSED_KEYS.has(91) && !PRESSED_KEYS.has(16)) {
  //         $('body').removeClass('hide-image');
  //       }
  //     });

  // function checkWindowFocused() {
  //   if (document.hasFocus()) {
  //     console.log('✅ window has focus');
  //     if (!PRESSED_KEYS.has(91) && !PRESSED_KEYS.has(16)) {
  //       $('body').removeClass('hide-image');
  //     }
  //   } else {
  //     console.log('⛔️ window does NOT have focus');
  //     $('body').addClass('hide-image');
  //   }
  // }
  
  // setInterval(checkWindowFocused, 500);
  

  /* copy protection [24/05/2024] */
  $('body').on('contextmenu', function(e){
    if (!$('body').hasClass('template-collection') && $(e.target).is('img')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  /* login modal */
  $('#login').show();
  $('#signup').hide();
  $('#recover_pwd').hide();
  $('.form_login_link').addClass('active');
  $('.form_login_link').click(function(){
    $('.form_signup_link').removeClass('active');
    $(this).addClass('active');
    $('#login').show();
    $('#signup').hide();
  });
  $('.form_signup_link').click(function(){
    $(this).addClass('active');
    $('.form_login_link').removeClass('active');
    $('#signup').show().addClass('active');
    $('#login').hide();
  });
  $('.recover_pwd_link').click(function(){
    $('#login').hide();
    $('#signup').hide();
    $('#recover_pwd').show();
  });
  
  /* header */
  $('a#inline').fancybox({
    hideOnContentClick: true,
    padding: 0
  });
  
  
  $('.pageNav').on('click', function(e){
    e.preventDefault();
    let $el = $(this);
    let __target = $el.attr('href') || $el.data('target') ;
  	$('html, body').scrollTop($(__target).offset().top - 150);
//     $('html, body').animate({
//       'scrollTop': $(__target).offset().top -150
//     }, 1000);
    return false;
  });
  
  /* account */
  let $accountTab = $('#Tabs.accountNav');
  if ($accountTab.length) {
    let $navs = $accountTab.find('.account-nav-item a[data-tab]');
    let $tabs = $accountTab.find('.navItem');
    $navs.on('click', function(e){
      let $el = $(this);
      $navs.removeClass('nav_active').filter($el).addClass('nav_active');
      $tabs.hide().filter('.' + $el.data('tab')).show();
      
      // for fix mobile active
      let $nav = $el.parents('.navbarSideList');
      $nav.removeClass('show');
    }); 
    
    if (location.hash) {
      $navs.filter('[data-id=' + location.hash.substr(1) + ']').click();
    } else {
      $navs.first().click();
    }
    $(window).on('hashchange', function(e) {
      if (location.hash) {
        $navs.filter('[data-id=' + location.hash.substr(1) + ']').click();
      }
    });
	
    // show menu
  }
  // for mobile
  if (!__isTabletAndUp) {
    // console.log(`Mobile mode`);
    // mobile menu
    $('#account, #sidebar-account').on('click', function(e){
      e.preventDefault();
//       console.log('account click');
      if ($(this).is('#sidebar-account')) {
       $('#sidebar-menu .Drawer__Close').click();
      }
      
      $('#account-m-menu').toggleClass('show');
      return false;
    });
    
    $('#close-m-menu').on('click', function(e){
      $('#account-m-menu').toggleClass('show');
    });
    
    $('#account-m-menu').on('click', 'a', function(e){
      $('#account-m-menu').toggleClass('show');
    });

    // mobile contact
    $('#section-emier-contact-body').each(function(){
      let $contact = $(this),
        $tabs = $contact.find('.CollapseTab');
      $tabs.on('click', '[data-for]', function(e){
        let _for = $(this).data('for');
        $tabs.filter(`[data-id=${_for}]`).toggleClass('CollapseTab-open');
      });
    });
  }
  
  /* account > consignment */
  let consignment_status = {
    1: 'Item Received',
    2: 'Product Available Online',
    3: 'Product Sold Online',
    4: 'Delivery Scheduled',
    5: 'Delivered',
    6: 'Payment Scheduled',
    7: 'Payment Processed',
    8: 'Consignment Done',
    20: 'Order Canceled',
    21: 'Order Return/Refund',
    31: 'Consignment Terminate',
    32: 'Waiting for collect/delivery',
    33: 'Item back to customer'
  };
  
  if ($accountTab.length) {
  	// setting template
    window.__emier['template'] = window.__emier.template || {};
    window.__emier.template['consign_item'] = '<tr><td>#SKU</td><td><div class="consignStatus close"><div class="currentStatus"><div class="date">#CURRENT_DATE</div><div class="status"><div class="collapse-link" data-active="open">#CURRENT_STATUS #DOWNLOAD</div></div></div><div class="statusProgress">#STATUS_PROGRESS</div></div></td></tr>';
//     window.__emier.template['consign_item'] = '<tr> <td><a href="/search?q=#SKU" target="_blank">#SKU</a></td> <td> <div class="consignStatus close"> <div class="currentStatus"> <div class="date">#CURRENT_DATE</div> <div class="status"> <div class="collapse-link" data-active="open">#CURRENT_STATUS #DOWNLOAD</div> </div> </div> <div class="statusProgress"> <div class="step active"> <div class="date">#DATE_[1]</div> <div class="status"> <div class="collapse-link" data-active="close"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Item Received </div> </div> </div> </div> <div class="step #CLASS_[2]"> <div class="date">#DATE_[2]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Product Available Online </div> </div> </div> <div class="step #CLASS_[3]"> <div class="date">#DATE_[3]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Product Sold Online </div> </div> </div> <div class="step #CLASS_[4]"> <div class="date">#DATE_[4]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Delivery Scheduled </div> </div> </div> <div class="step #CLASS_[5]"> <div class="date">#DATE_[5]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Delivered </div> </div> </div> <div class="step #CLASS_[6]"> <div class="date">#DATE_[6]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Payment Scheduled </div> </div> </div> <div class="step #CLASS_[7]"> <div class="date">#DATE_[7]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Payment Processed </div> </div> </div> <div class="step #CLASS_[8]"> <div class="date">#DATE_[8]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Consignment Done </div> <div class="file"> <a href="https://rocky-tor-12613.herokuapp.com/pdf/payment?u=#EMAIL&i=#SKU">Download Payment Invoice <img class="icon" src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/icon-attach.png?v=1617862577"></a></div> </div> </div> </div> </div> </td></tr>';
    window.__emier.template['consign_item_terminate'] = '<tr> <td>#SKU</td> <td> <div class="consignStatus close"> <div class="currentStatus"> <div class="date">#CURRENT_DATE</div> <div class="status"> <div class="collapse-link" data-active="open">#CURRENT_STATUS</div> </div> </div> <div class="statusProgress"> <div class="step active"> <div class="date">#DATE_[1]</div> <div class="status"> <div class="collapse-link" data-active="close"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Item Received </div> </div> </div> </div> <div class="step #CLASS_[2]"> <div class="date">#DATE_[2]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Product Available Online </div> </div> </div> <div class="step terminate #CLASS_[31]"> <div class="date">#DATE_[31]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Consignment Terminate </div> </div> </div> <div class="step terminate #CLASS_[32]"> <div class="date">#DATE_[32]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Waiting for collec/delivery </div> </div> </div> <div class="step terminate #CLASS_[33]"> <div class="date">#DATE_[33]</div> <div class="status"> <div class="icon"> <img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"> </div> <div class="text"> Item back to customer </div> </div> </div> </div> </div> </td></tr>';
  
    let $tab = $accountTab.find('.consignmentTab');
    let $tm = $tab.find('.ConsignmentTable');
    let $td = $tab.find('.ConsignItemsTable');
    //get data
    jQuery.ajax({
      url: 'https://rocky-tor-12613.herokuapp.com/api/consignments/' + window.__emier.customer.email,
      success: function(data) {
//         console.log(data);
        $tab.find('.Loading').addClass('Hidden');
        if (data.length) {
//           $tab.find('.Segment').addClass('Hidden');
          $tab.find('.TableWrapper').removeClass('Hidden');
          let $tbody = $tm.find('tbody');
          let sb = [];
          for (i in data) {
            let row = data[i];
            let sb = [];
            let ic = row.items.length;
            let ia = 0;
            for (j in row.items) {
              if (row.items[j].status < 3) {
                ia++;  
              }
            }
            let st = (ia == 0 ? 'PAID' : (ia == ic ? 'OPEN' : 'PARTIALLY PAID'));
            sb.push('<tr>');
            sb.push('<td>#' + row.id + '</td>');
            sb.push('<td class="hidden-sm">' + st + '</td>');
            sb.push('<td class="pop-info">' + ia + '/' + ic);
            sb.push(`<div class="unit-popover hidden-md"> <button type="button" class="SelectButton Link Link--primary u-h8" aria-haspopup="true" aria-expanded="false" aria-controls="consign-unit-popover-${i}"><svg class="Icon Icon--question" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g><g><path d="M256,0C114.848,0,0,114.848,0,256s114.848,256,256,256s256-114.848,256-256S397.152,0,256,0z M256,480 C132.48,480,32,379.52,32,256S132.48,32,256,32s224,100.48,224,224S379.52,480,256,480z"></path></g></g> <g><g><path d="M256,96.032c-52.944,0-96,43.056-96,95.968h32c0-35.28,28.704-63.968,64-63.968s64,28.704,64,64s-28.704,64-64,64 c-8.832,0-16,7.168-16,16V352h32v-65.312c45.344-7.648,80-47.184,80-94.672C352,139.088,308.944,96.032,256,96.032z"></path></g></g> <g><g><rect x="240" y="384" width="32" height="32"></rect></g></g> </svg></button> <div id="consign-unit-popover-${i}" class="Popover Popover--small Popover--noWrap Popover--positionTop Popover--alignCenter" aria-hidden="true"> <header class="Popover__Header"></header> <div class="Popover__Content"> <div class="Popover__ValueList Popover__ValueList--center" data-scrollable="">${st}</div> </div> </div></div>`);
            sb.push('</td>');
            sb.push('<td>' + row.apply_at + '</td>');
            sb.push('<td class="hidden-sm"><a class="e-item"><i class="fas fa-list"></i></a></td>');
            sb.push('</tr>');
            $(sb.join('')).appendTo($tbody).data('consignment', row);
          }
        }
        else {
          $tab.find('.Segment').removeClass('Hidden');
        }
      }
    });
    
    // build template data set
    let _dtn = {'#SKU': '', '#CURRENT_DATE': '', '#CURRENT_STATUS': ''};
    let _dtr = {..._dtn};
//     for (i=1; i<=8; i++) {
//       _dtn['#DATE_[' + i + ']'] = '';
//       _dtn['#CLASS_[' + i + ']'] = '';
//     }
    
//     for (i=1; i<=2; i++) {
//       _dtr['#DATE_[' + i + ']'] = '';
//       _dtr['#CLASS_[' + i + ']'] = '';
//     }
//     for (i=11; i<=13; i++) {
//       _dtr['#DATE_[' + i + ']'] = '';
//       _dtr['#CLASS_[' + i + ']'] = '';
//     }
  	
//     console.log(_dtn);
//     console.log(_dtr);
    
    // items
    $tm.on('click', 'tbody tr', function(e) {
//       console.log($(this).data('consignment'));
      e.preventDefault();
      let $et = $(e.target);
      
      if ($et.is('.SelectButton') || ($et.is('.pop-info') && $et.find('.unit-popover:visible').length)) {
        e.stopPropagation();
        $et = $et.is('.SelectButton') ? $et : $et.find('.SelectButton');
        $('#Tabs .Popover').attr('aria-hidden', true);
      	$p = $('#'+$et.attr('aria-controls'));
        $p.css('top', '-42px')
        .css('left', `-${$p.width()/2 - 18}px`)
        	.attr('aria-hidden', false);
        
        $('#Tabs').one('click', function(e) {
        	$('#Tabs .Popover').attr('aria-hidden', true);
        });
        return false;
      } else {
        
        $tm.addClass('Hidden');
        $td.removeClass('Hidden');

        let $e = $(this);
        let $tbody = $td.find('tbody').empty();
        let data = $e.data('consignment');

        $td.find('.consignment').text('#' + data.id);
        
        let cpl_receive = _.template('<div class="step <%= classes %>"><div class="date"><%= date %></div><div class="status"><div class="collapse-link" data-active="close"><div class="icon"><img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"></div><div class="text"><%= text %></div></div></div></div>');
        let cpl_status = _.template('<div class="step <%= classes %>"><div class="date"><%= date %></div><div class="status"><div class="icon"><img src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/consginment-icon.png?v=1616057123"></div><div class="text"><%= text %></div><%= link %></div></div>');

        let sb = [];
        // normal progress
        for (i in data.items) {
          let _dt, _t;
          let item = data.items[i];
          let historys = item.historys;
          let last = historys[historys.length - 1];
          let email = encodeURIComponent(window.__emier.customer.email);
          let download_link = `https://rocky-tor-12613.herokuapp.com/pdf/payment?u=${email}&i=${item.id}`;
          
          _dt = {..._dtn};
          _t = window.__emier.template.consign_item;
//           if (last.status_id < 10) {
//             _dt = {..._dtn};
//             _t = window.__emier.template.consign_item;
//           } else {
//             _dt = {..._dtr};
//             _t = window.__emier.template.consign_item_terminate;
//           }
          _dt['#SKU'] = item.id;
          _dt['#CURRENT_DATE'] = last.update_at;
          _dt['#CURRENT_STATUS'] = consignment_status[item.status];
          _dt['#DOWNLOAD'] = (item.status == 8 ? `<a href="${download_link}" class="download_pdf"><img class="icon" src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/icon-attach.png?v=1617862577"></a>` : '');
          
          let st_sb = [];
          for (j in historys) {
            let it = historys[j];
            _dt['#DATE_[' + it.status_id + ']'] = it.update_at;
            _dt['#CLASS_[' + it.status_id + ']'] = 'active';
            
            let _cpl = it.status_id == 1 ? cpl_receive : cpl_status;
            let _data = {
              classes: it.status_id < 30 ? 'active' : 'terminate active',
              date: it.update_at,
              text: consignment_status[it.status_id] + (it.status_id >= 20 && it.status_id < 30 ? ` [${it.note}]` : ''),
              link: it.status_id == 8 ? `<div class="file"> <a href="${download_link}">Download Payment Invoice <img class="icon" src="https://cdn.shopify.com/s/files/1/0337/1453/6587/files/icon-attach.png?v=1617862577"></a></div>` : '',
            }
            st_sb.push(_cpl(_data));
          }
          // add default progress
          if (item.status < 8) {
            let _cpl = cpl_status;
            for (i=item.status+1; i<=8; i++) {
              let _data = {
                classes: '',
                date: '',
                text: consignment_status[i],
                link: '',
              }
              st_sb.push(_cpl(_data));
            }
          }
//           console.log(st_sb.join(''));
          
          _dt['#STATUS_PROGRESS'] = st_sb.join('');
//           _dt['#EMAIL'] = email;
  //         console.log(_dt);
          for (i in _dt) {
            _t = _t.replaceAll(i, _dt[i]);
          }
          sb.push(_t);
        }
        $tbody.append(sb.join(''));
      }
    });
    
    $td
    .on('click', '.collapse-link .download_pdf', function(e) {
    	e.stopPropagation();
    })
    .on('click', '.collapse-link', function(e){
      var $e = $(this);
      $e.parents('.consignStatus').removeClass('open close')
      .addClass($e.attr('data-active'));
    })
    .on('click', 'a.back-link, a.consignment', function(e){
      e.preventDefault();
      $td.addClass('Hidden');
      $tm.removeClass('Hidden');
      return false;
    });
  }	/* end of account - consignment */
  
  /* account - identify */
  if ($accountTab.length) {
//     $('#btn_apply_id_check').removeAttr('disabled');
    $('#btn_apply_id_check').on('click', function(e) {
      e.preventDefault();
      console.log('apply id check');
      let $btn = $(this);
      
      if ($btn.attr('disabled')) {
        return false;
      }
      
      let _btn_text = $btn.text();
      let $text = $('#identify_status_text');
      let $icon = $('#identify_status_icon');
      let $alert = $('#identify_alert');
      let $message = $('#identify_alert_message');
      $btn.attr('disabled', true);
      
//       $text.text('In Progress');
//       $icon.attr('class', 'in-progress');
//       $message.attr('class', 'success')
//       	.text(`Your application is received, an email with verification link has been sent, please check your inbox.`);
//       $alert.addClass('show');
//       $message.attr('class', 'error')
//       	.html(`Something go wrong! Please contact <a href="mailto:info@emier.com.au">customer service</href>.`);
//       $alert.addClass('show');
//       $btn.removeAttr('disabled');
      
      $.ajax({
        url: 'https://rocky-tor-12613.herokuapp.com/api/applyIDCheck',
        type: 'POST',
        data: window.__emier.customer,
        success: function(data, status, jqXHR) {
          $text.text('In Progress');
          $icon.attr('class', 'in-progress');
          $message.attr('class', 'success')
          	.text(`Your application is received, an email with verification link has been sent, please check your inbox.`);
          $alert.addClass('show');
        },
        error: function(jqXHR, status, error) {
          console.log(`status: ${status}`);
          console.log(error);
          $btn.removeAttr('disabled');
          $message.attr('class', 'error')
          	.html(`Something go wrong! Please contact <a href="mailto:info@emier.com.au">customer service</href>.`);
          $alert.addClass('show');
        }
      });
      
    });
  }
  
  /* product */
  $('#productConditionLink').fancybox({
    hideOnContentClick: true,
    padding: 0
  });
  
  /* collection */  
  let $collection = $('#shopify-section-collection-template');
//   console.log('hello');
  if ($collection.length) {
    let $filters = $collection.find('.CollectionFilters').first();
    let $sort, _svg;
    
    if (__isTabletAndUp) {
      $sort = $collection.find('.CollectionToolbar__Item--sort');
      _svg = $sort.find('svg').get(0).outerHTML;
      // add default sort text
      let $popover = $('#collection-sort-popover');
      $sort.html($popover.find('.is-selected').text().trim() + _svg);
    }
    
//     console.log('collection filter:' + $filters.length);
    $collection.on('click', function(e) {
      var $el = $(e.target);
      if ($el.is('[data-e-action]')) {
        e.preventDefault();
//         console.log($el.attr('data-e-action'));
        if ($el.is('[data-e-action="toggle-tag"]')) {
          let tag = $el.attr('data-tag');
          console.log($filters.find('[data-tag="' + tag + '"]').length);
          $filters.find('[data-tag="' + tag + '"]').click();
          
          // exec apply in mobile mode
          if (!__isTabletAndUp) {
            let $drawer = $('#collection-filter-drawer');
            let $btn = $drawer.find('[data-action="apply-tags"]');
            $btn.click();
          }
        }
      } else if ($el.is('span.checkbox')) {
        $el.parent('label').click();
      } else if ($el.is('label')) {
        var $ava = $filters.find('[data-tag="available"]');
        if ($el.hasClass('is-checked')) {
          $el.removeClass('is-checked');
        } else {
          $el.addClass('is-checked')
        }
        $ava.click();
      }
      // exec sort content change
      if (__isTabletAndUp && $el.is('[data-action="select-value"]')) {
        $sort.html($el.text().trim() + _svg); 
      }
    });
  }

  // 08/11/22 Feat: Disable Register
  function disableRegister() {
    var $ssw_sum = $('#signup_modal .ssw-modal-body');
    $ssw_sum.find('.ssw-socialconnect').hide();
    $ssw_sum.find('form').hide();
    // Disable Register
    if ($ssw_sum.find('.signup-announcement').length == 0) {
      $ssw_sum.append(`<div class="signup-announcement">
            <p>Dear customer,</p>
            <p>Due to recent data breaches and cyber attacks in Australia, we temporarily stopped accepting new online customer sign ups. </p>
            <p>You can still complete your purchase with our assistance. Please contact <b>Customer Support</b> for any purchase enquires. </p>
            <p>Customer verification will be required with all online payments. </p>
            <p>Emier reserves the right to cancel any order that cannot be verified. A 3% cancellation fee will be charged for any cancelled fraudulent orders. </p>
            <p>Thank you for your continued support and understanding. </p>
            <p>Please contact Customer Support via</p>
            <p>
              <strong>Online Chat</strong> <br>
              <strong>Phone:</strong> 1300 228 883 <br>
              <strong>Instagram:</strong> <br>
              Collins Street Store: @the.emier <br>
              Glen Waverley Store: @the.emier.glen <br>
              <strong>Whatsapp:</strong> <br>
              Collins Street Store : +61 466 638 888 <br>
              Glen Waverley Store: +61 466 628 888 <br>
              <strong>WeChat:</strong> <br>
              Collins Street Store: emier2406 <br>
              Glen Waverley Store: emier0809
            </p>
          </div>
          <style>
            .ssw-login .signup-announcement {
              margin: 3em 1em;
            }
            .ssw-login .signup-announcement p {
              text-align: justify;
              font-size: 14px;
            }
          </style>`);
    }

    // add announcement
    $ssw_lim = $('#login_modal .ssw-modal-body');
    if ($ssw_lim.find('.login-announcement').length == 0) {
      $ssw_lim.append(`<div class="login-announcement">
            <p>Due to recent data breaches and cyber attacks in Australia, </p>
            <p>Customer verification might be required for all online payments.</p>
            <p>Emier reserves the right to cancel any order that cannot be verified. A 3% cancellation fee will be charge for any cancelled fraudulent orders.</p>
            <p>Thank you for your continued support and understanding.</p>
          </div>
          <style>
            .ssw-login .login-announcement {
              margin: 1.5em auto 1em;
              width: 80%;
            }
            .ssw-login .login-announcement p {
              margin-bottom: 8px;
              text-align: justify;
              font-size: 14px;
            }
          </style>
      `);
    }
    $ssw_lim.find('.ssw-socialconnect').remove();
  }

  // 11/08/22 Fix: Growave's login & signup switch issue
  $('body').on('click', '#login_modal .ssw-modal-dialog .ssw-modal-footer', function(e) {
    // 11/08/22 Feat: Disable Register
    // disableRegister();
    ssw('#login_modal').sswModal('hide'); 
    ssw('#signup_modal').sswModal('show'); 
  });

  $('body').on('click', '#signup_modal .ssw-modal-dialog .ssw-modal-footer', function(e) {
    // disableRegister();
    ssw('#signup_modal').sswModal('hide'); 
    ssw('#login_modal').sswModal('show');
  });

  // $('body').on('click', '#customer_register_link', function(e) {
  //   disableRegister();
  // });
  
  // $('body').on('click', '#customer_login_link', function(e) {
  //   disableRegister();
  // });

  // career-page
  // function setApplyForm() {
  //   console.log('set apply form');
  //   let $frame = $('#frame_79l3oay4teB4I0LKSjQroA')
  //   let $input_position = $frame.contents().find('#form_input_0');
  //   let $input_location = $frame.contents().find('#form_input_1');
  //   if ($input_position.length) {
  //     $input_position.val(window._career?.position);
  //     $input_location.val(window._career?.location);
  //     console.log('sucess set apply form');
  //   } else {
  //     setTimeout(setApplyForm, 500);
  //   }
  // }
  // let $applyForm = $('.apply-form');
  // console.log(`apply-form ${$applyForm.length}`);
  // if ($applyForm.length) {
  //   console.log(window._career);
  //   setTimeout(setApplyForm, 500);
  // }

  /** ===== collection seo start ===== */
  let $switcher = $('.CollectionDescription-switcher, .SEODescription-switcher');
  if ($switcher.length) {
    console.log(`Collection SEO`);
    let ref = $switcher.data('ref');
    let toggleClass = $switcher.data('toggle');
    let $collapse = $(`#${ref}`);
    $switcher.on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $switcher.toggleClass(toggleClass);
      $collapse.toggleClass(toggleClass);
    });
  }
  /** ===== collection seo end ===== */

  /** ===== countdown start ===== **/
  // countdown('event-countdown');
  /** ===== countdown end ===== **/

  /** ===== social boost start ===== **/
  function modifyAmpcWidgetContent() {
    let $widget = $('.ampc__widget');
    let isLogin = window.__emier?.customer;
    let isRegistered = $widget.find('.ampc__loggedIn').length > 0;

    // rewrite contont when user doesn't have entry
    if (isLogin && !isRegistered) {
      $widget.find('.ampc__homeContent .ampc__h1').html('Your Entries: 0');
      $widget.find('.ampc__homeContent .ampc__p').html('');
      // change button content
      $widget.find('.ampc__button').html(` View Details <svg width="1.6em" height="1.6em"><use xlink:href="#icon-arrow-next"></use></svg>`);
    }
    // reset the button link
    $widget.find('.ampc__button').removeAttr('onclick').bind('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      let $el = $(this);
      let text = $el.text().trim();
      if (text.toLowerCase() == 'login now') {
        PUCMethods.redirectToShop("http://emier.com.au/account/login");
        PUCMethods.close(46779);
      } else if (text.toLowerCase() == 'view details') {
        PUCMethods.redirectToShop("http://emier.com.au/pages/giveaway");
        PUCMethods.close(46779);
      } else {
        PUCMethods.redirectToShop("http://emier.com.au/collections/new-arrivals/available");
        PUCMethods.close(46779);
      }
      return false;
    });
    // add view details link
    if ($widget.find('.ampc__homeContent .ampc__emierLink').length == 0) {
      $widget.find('.ampc__homeContent')
        .append(`<div class="ampc__emierLink"><a href="//emier.com.au/pages/giveaway">VIEW DETAILS</a></div>`);
    }
    // console.log('=== modifyAmpcWidgetContent ===');
  }
  function findAmpcWidget() {
    if ($('.ampc__widget').length > 0) {
      $(document).unbind('DOMSubtreeModified', findAmpcWidget);
      setTimeout(modifyAmpcWidgetContent, 100);
    }
    // console.log('=== findAmpcWidget ===');
  }
  function listenToAmpcWidget() {
    $(document).bind('DOMSubtreeModified', findAmpcWidget);
    // console.log('=== listenToAmpcWidget ===');
  }
  function initAmpcCustom() {
    // clear the widget listening event
    // $(document).off('mouseenter', '.ampc__widget', initAmpcCustom);
    $(document).off('click', '.am-widgetbar-cta', initAmpcCustom);
    setTimeout(listenToAmpcWidget, 100);
    // console.log('=== initAmpcCustom ===');
  }
  // $(document).on('mouseenter', '.ampc__widget', initAmpcCustom);
  $(document).on('click', '.am-widgetbar-cta', initAmpcCustom);
  /** ===== social boost end ===== **/

  /** ===== Product Page ===== **/
  if (window.location.pathname.includes('/products/') || window.location.pathname.includes('/products_preview')) {
    console.log('===== product page =====');
    
    /** ----- 16/06/23 ----- **/
    /** ===== products page description modify start ===== **/
    let $description = $('.ProductMeta__Description');
    if ($description.length) {
      /** ----- 16/06/23 ----- **/
      /** ===== products page measurement notes start ===== **/
      let $measurement = $description.find('p:contains(Measurement:)');
      $measurement.after(`<p data-elem-builder="custom.js"><span class="notes">* Mere Estimates, Use for Indication of Size Only</span></p>`);
      /** ===== products page description modify end ===== **/
      
      /** ----- 06/09/23 ----- **/
      /** ===== products page condition slider start ===== **/
      let conditions = [
        { label: "Under 9", matches: ["under 9"]},
        { label: "9.0/10", matches: ["9/10", "9.0/10"]}, 
        { label: "9.5/10", matches: ["9.5/10"]}, 
        { label: "9.8/10", matches: ["9.8/10"]},
        { label: "9.9/10", matches: ["9.9/10"]}, 
        { label: "10/10", matches: ["10/10"]}
      ];
      let $condition = $description.find('p:contains(Condition:)');
      let productCondition = $condition.text().replace(/[Condition:]|\s/g, "").replace(/[^a-zA-Z0-9\.\/]/g,'');
        _items = [];
      let _score = 0;
      conditions.forEach((cond, i) => {
        let _productCond = new String(productCondition).valueOf().trim().toLowerCase();
        let isMatch = (i === 0 ? Number(_productCond == 'under 9' ? "8" : _productCond.replace("/10", "")) < 9 : cond.matches.includes(_productCond));
        _items.push(`<li class="ConditionSlider-item ${isMatch ? " ConditionSlider-item--selected" : ""}">${cond.label}</li>`); 
        if (isMatch) {
          _score = i;
        }
      });
      
      $condition.after(`<ul class="ConditionSlider ConditionSlider-score-${_score}" data-elem-builder="custom.js">${_items.join("")}</li>`);
      /** ===== products page condition slider end ===== **/

      /** ----- 21/09/23 ----- **/
      /** ===== products page size guide start ===== **/
      let $guide = $description.find('p:contains(SIZE & FIT)');
      if ($guide.length) {
        $guide.html('<b>SIZE & FIT</b><a id="ProductSizeGuide__Link" href="#ProductSizeGuide__Content" data-elem-builder="custom.js">size guide</a>');
        $("#ProductSizeGuide__Link").fancybox({
          hideOnContentClick: true,
          padding: 0
        });
      }
      /** ===== products page size guide end ===== **/
    }
    /** ===== products page description modify end ===== **/

    /** ----- 29/07/23 ----- **/
    /** ===== chckout confirm start ===== **/
    // console.log('checkout confirm -------------->');
    const product_buy_direct_selector = '.product-buy-direct-block',
      btn_payment_selector = '.ProductForm .shopify-payment-button .shopify-payment-button__button';
    
    // console.log($(btn_payment_selector).length);
    
    if ($(btn_payment_selector).length) {
      console.log('direct init');
      initBuyButton();
    }

    // 04/04/24 shoify change the flow of "buy it now" again
    // console.log('bind but it now -->>>');
    $(product_buy_direct_selector).bind('DOMSubtreeModified', initBuyButton);

    function initBuyButton(e) {
      const now = Date.now();
      const lastInitBuyButtonTime = window._lastInitBuyButtonTime ?? 0;
      if (now - lastInitBuyButtonTime < 50) {
        // console.log(`too short ${now} & ${lastInitBuyButtonTime}`);
        return;
      }
      console.log('initBuyButton');
      let btn_selector = btn_payment_selector,
        popup_link_selector = 'a#buy-confirm',
        popup_content_selector = '#buy-confirm-popup',
        $btn = $(btn_selector);
      if ($btn.length) {
        console.log('default disable paymnt button');
        initProductPaymentButton(btn_selector, popup_link_selector, popup_content_selector, () => {
          console.log('=== initBuyButton INIT ===');
          console.log(`${btn_selector} ${$btn.length}`);
          // $(product_buy_direct_selector).unbind('DOMSubtreeModified', initBuyButton);
        });
      }
      window._lastInitBuyButtonTime = now;
    }

    initBuyButtonTimeout(0);
    function initBuyButtonTimeout(count = 0) {
      setTimeout(() => {
        let btn_selector = btn_payment_selector,
          popup_link_selector = 'a#buy-confirm',
          popup_content_selector = '#buy-confirm-popup',
          $btn = $(btn_selector);
        if ($btn.length) {
          initProductPaymentButton(btn_selector, popup_link_selector, popup_content_selector, () => {
            console.log('=== initBuyButton INIT ===');
            console.log(`${btn_selector} ${$btn.length}`);
          });
        }
        if (count<20) {
          // console.log(`initBuyButtonTimeout ${count}`);
          initBuyButtonTimeout(++count);
        }
      }, 500);
    }

    function initProductPaymentButton(btn_selector, popup_link_selector, popup_content_selector, initFn = null) {
      $el = $(btn_selector);
      console.log(`init product payment button ${btn_selector} has ${$el.length}`);
      
      if ($el.find('.Button_Confirm__Cover').length < 1) {
        // console.log('build check a [' + btn_selector + '] ' + $el.length);
        setTimeout((e) => {
          $el = $(btn_selector);
          // console.log('build check b [' + btn_selector + '] ' + $el.length);
          if ($el.find('.Button_Confirm__Cover').length < 1) {
            // console.log('build check c [' + btn_selector + '] ' + $el.length);
            // console.log($el[0]);
            // add confirm cover and binding event
            $cover = $(`<div class="Button_Confirm__Cover"></div>`)
              .on('click', function(e) {
                if ($(e.target).is('.Button_Confirm__Cover')) {
                  e.preventDefault();
                  e.stopPropagation();
                  // console.log('click btn cover');
                  // console.log($el.get(0));
                  $el.attr('disabled', true);
                  $(popup_link_selector).trigger('click');
                  return false;
                }
              }).appendTo($el);
            // init checkout confirm popup
            initCheckoutConfirmPopup(btn_selector, popup_link_selector, popup_content_selector, initFn);
          }
        }, 50);
      }
    }
    /** ===== chckout confirm end ===== **/
  }
  
  /** ----- 29/07/07 ----- **/
  /** ===== chckout confirm start ===== **/
  function initCheckoutConfirmPopup(btn_selector, popup_link_selector, popup_content_selector, initFn = null) {
    const $btn = $(btn_selector),
      $poplink = $(popup_link_selector),
      $popContent = $(popup_content_selector);

    if (initFn) {
      initFn();
    }

    function checkoutConfirmCoutdown() {
      const $content = $(popup_content_selector),
        $btnAgree = $content.find('.Button__Confirm__Agree');
      const nextNum = $content.attr('countdown') - 1;
      if (nextNum > 0) {
        // console.log(`--- countdown ${countdown} ---`);
        $content.data('hasRead', false).attr('countdown', nextNum);
        $btnAgree.text(`Agree(${nextNum})`).addClass('Button-disabled');
        const timeout = setTimeout(() => {
          checkoutConfirmCoutdown();
        }, 1000);
        $content.attr('timeout', timeout);
      } else {
        $content.data('hasRead', true);
        $btnAgree.text('Agree').removeClass('Button-disabled');
      }
    }
    // init fancybox
    $poplink.fancybox({
      helpers: {
        overlay: { closeClick: false }
      },
      padding: 0,
      afterShow: () => {
        const countdown = 8;
        $popContent
          .attr('countdown', countdown)
          .find('.confirm-message').text('');
        const timeout = $popContent.attr('timeout');
        clearTimeout(timeout);
        checkoutConfirmCoutdown();
      }
    });
    // binding button event on content
    $popContent
      .on('click', '.Button__Confirm__Agree', (e) => {
        if ($popContent.data('hasRead')) {
          // console.log($btn.get(0));
          $popContent.find('.confirm-message').text('');
          $btn.attr('disabled', false);
          $btn.trigger('click');
        } else {
          $popContent.find('.confirm-message').text('*Please read all before agree.');
        }
      })
      .on('click', '.Button__Confirm__Disagree', (e) => {
        $btn.attr('disabled', true);
        $.fancybox.close();
      });
  }

  function cartCheckoutConfirmHandle(e) {
    let btn_selector = 'button.Cart__Checkout',
      popup_link_selector = 'a#checkout-confirm',
      $cover = $(this);
    e.preventDefault();
    e.stopPropagation();
    $cover.parent().attr('disabled', true);
    $(popup_link_selector).trigger('click');
    return false;
  }

  // to bind Button disabled cover event
  function initCartCheckoutConfirmButton() {
    let btn_selector = 'button.Cart__Checkout',
      popup_link_selector = 'a#checkout-confirm',
      popup_content_selector = '#checkout-confirm-popup',
      $btn = $(btn_selector),
      $cover = $btn.find('.Button_Confirm__Cover');
    
    if ($cover.length && $cover.data('event-binding') !== 'binded') {
      // console.log('=== initCartCheckoutConfirmButton ===');
      initCheckoutConfirmPopup(btn_selector, popup_link_selector, popup_content_selector, () => {
        // console.log('=== initCartCheckoutConfirmButton INIT ===');
        $cover.on('click', cartCheckoutConfirmHandle).data('event-binding', 'binded');
      });
      
      // $cover.on('click', cartCheckoutConfirmHandle).data('event-binding', 'binded');
      // // init fancybox 
      // $(popup_link_selector).fancybox({
      //   hideOnContentClick: true,
      //   padding: 0
      // });
      // // bind event
      // $(popup_content_selector)
      //   .on('click', '.Button__Confirm__Agree', (e) => {
      //     $btn.attr('disabled', false);
      //     $btn.trigger('click');
      //   })
      //   .on('click', '.Button__Confirm__Disagree', (e) => {
      //     $btn.attr('disabled', true);
      //     $.fancybox.close();
      //   });
    }
  }
  // double check for make sure Button_Disabled_Cover work
  $('#sidebar-cart').on('mouseover', function(e) {
    initCartCheckoutConfirmButton();
  });
  
  if (window.location.pathname.includes('/cart')) {
    // console.log('===== Cart page =====');
    $('#shopify-section-cart-template').on('mouseover', '.Cart__Footer', function(e) {
      initCartCheckoutConfirmButton();
    });
  }
  // bind event
  setTimeout(initCartCheckoutConfirmButton, 200);
  // init checkout confirm modal
  
  /** ===== chckout confirm end ===== **/

});  // jQuery Ready End

$('.toggle_forgot').click(function(){
  $('#recover_customer_password').show();
});

// to use this function, add <div class="{id}"></div> element in html
function countdown(id) {
  const pad_length = 2,
    pad_string = '0';
  let $count = $(`#${id}`);
  if ($count.length) {
    let _end = $count.data('end-date');
    console.log(`==== countdown ${_end} ===`);
    let countDownDate = new Date(_end).getTime();

    $count.html(`<div class="block">
                  <div id="event-countdown-days" class="number">00</div>
                  <div class="unit">DAYS</div>
                </div>
                <div class="block">
                  <div id="event-countdown-hours" class="number">00</div>
                  <div class="unit">HOURS</div>
                </div>
                <div class="block">
                  <div id="event-countdown-mins" class="number">00</div>
                  <div class="unit">MINS</div>
                </div>
                <div class="block">
                  <div id="event-countdown-sec" class="number">00</div>
                  <div class="unit">SEC</div>
                </div>`);

    // Update the count down every 1 second
    let x = setInterval(function() {
    
      // Get today's date and time
      let now = new Date().getTime();
    
      // Find the distance between now and the count down date
      let distance = countDownDate - now;
    
      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
      // Display the result in the element with id="demo"
      // $count.html(days + "d " + hours + "h "
      // + minutes + "m " + seconds + "s ");
      $('#event-countdown-days').html(String(days).padStart(pad_length, pad_string));
      $('#event-countdown-hours').html(String(hours).padStart(pad_length, pad_string));
      $('#event-countdown-mins').html(String(minutes).padStart(pad_length, pad_string));
      $('#event-countdown-sec').html(String(seconds).padStart(pad_length, pad_string));
    
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        $('#event-countdown-days').html('00');
        $('#event-countdown-hours').html('00');
        $('#event-countdown-mins').html('00');
        $('#event-countdown-sec').html('00');
      }
    }, 1000);
  }
}

